export default __webpack_public_path__ + "static/media/review_1@3x.c8547cbe.png";